/* The delivery slip beside the delivered piece (see delivery.tsx). */

.delivery {
  position: fixed;
  top: 50%;
  right: max(16px, 5vw);
  --slip-width: min(42vw, calc((100dvh - 156px) * 0.72), 480px);
  /* As wide as the slip, but never so narrow the buttons' names break onto a second line. */
  width: max(var(--slip-width), min(300px, calc(100vw - 24px)));
  display: flex;
  flex-direction: column;
  gap: 10px;
  transform: translateY(-50%);
}

:global(.shelf-open) .delivery {
  display: none;
}

.slip {
  position: relative;
  align-self: center;
  width: var(--slip-width);
}

.slipImage {
  display: block;
  width: 100%;
  border-radius: 6px;
  box-shadow: 0 10px 30px rgba(120, 80, 50, 0.25);
}

.stamp {
  position: absolute;
}

/* Each the same width where they fit, and a longer name takes more of the row than break. */
.actions button {
  flex: 1;
  padding-inline: 10px;
  white-space: nowrap;
}

/* Tall screens: the piece moves up, the slip comes in below it. */
@media (max-aspect-ratio: 1/1) {
  .delivery {
    top: auto;
    bottom: 12px;
    left: 50%;
    right: auto;
    --slip-width: min(calc(100vw - 24px), calc((50dvh - 116px) * 0.72));
    transform: translateX(-50%);
  }
}

.progress {
  margin: 8px 0;
  padding: 10px;
  border-radius: 12px;
  background: var(--panel);
  font-size: 13px;
  line-height: 1.6;
}
